<script>
  import { onMount, tick } from "svelte";
  import i18next from "i18next";
  import Modal from "svelte-simple-modal";
  import Tour from "./Tour.svelte";
  import TourVr from "./TourVr.svelte";

  /* ____________ Mobile Detection ____________ */
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";

  let config;
  const fetchConfig = async () => {
    while (!config) {
      try {
        const response = await fetch("./build/tour-config.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        config = await response.json();
      } catch (error) {
        console.error(
          "Unable to fetch tour config. Retrying...",
          error,
        );
        await new Promise((resolve) => setTimeout(resolve, 3000)); // Retry after 3 seconds
      }
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isVr = urlParams.has("vr");
  const fromEmbed = urlParams.has("fromEmbed");
  const embedId = urlParams.get("embedId");

  onMount(async() => {
    await fetchConfig();
    // set up i18n
    i18next.changeLanguage(config.language || 'en');
  });
</script>

<!-- /*____________ Markup ____________*/ -->
<main>
  {#if config}
    {#if isVr}
    <!-- VR -->
      <TourVr tour={config} />
    {:else}
    <!-- Normal -->
      <Modal>
        <Tour tour={config} {fromEmbed} {embedId} />
      </Modal>
    {/if}
  {/if}
</main>

<!-- /*____________ CSS ____________*/ -->
<style>
  main {
    padding: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
  }

  :global(html, body) {
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin: 0;
  }

  :global(.no-select) {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
